/**
 * 共同作業者（第 1b 段・2026-10-22 core/handoff-1b）の英語の文言。en.ts が `...enMembers` で取り込む（ja.members.ts が同じキーを全部持つことを型で強制）。
 * 使う画面: pages/MembersPage.tsx（メンバー）・components/OwnerOnly.tsx（持ち主だけの画面・欄）・プロジェクトの一覧の「Helping」の印・
 *   pages/TransferPage.tsx（渡した後も手伝う）・pages/TransferIncomingPage.tsx（前の持ち主が残る）。監査ログの文は en.ts の audit.*（auditWords.test.ts が en.ts を読む）。
 * 閉じた機能の言葉（売上・通報など = wordsPass.test.ts の CLOSED）は使わない（この画面は切り替えの外）。
 *
 * 言葉の決め事（plainWords.test.ts）: 中の言葉（API・secret key・environment・production・deploy・token・developer）を使わない。
 *   本番 = 「the published app」（「the live app」は使わない = plainWords.test.ts）・sk_ = 「server-only keys (starting with sk_)」。共同作業者 = 「collaborator」（ja は「共同作業者」）。
 * WHY 「できること / できないこと」を画面の上に並べるか: 招く持ち主（受託のクライアント）が、相手に何を任せるのかを招く前に分かるように。
 *   founder の決定（10/21）= 共同作業者は公開中のアプリも新しくできる・使った分の利用料は持ち主が払う、を言い切る
 */
export const enMembers = {
  'nav.members': 'Members',

  'members.title': 'Members',
  'members.lead.owner':
    'Add people who help you build this project — for example the person who built it for you. They sign in with their own {product} account. You stay the owner and pay for usage, including what they use.',
  'members.lead.member': 'You help with this project as a collaborator. The owner pays for usage and decides who can help.',
  'members.can.title': 'Collaborators can',
  'members.can.body': 'Fix and publish the app (the published app too — the owner gets an email each time), change settings, publish Functions, look at logs and data, and help with users (search and ban).',
  'members.cannot.title': 'Only the owner can',
  'members.cannot.body': 'Handle money (prepaid balance and payments), create or turn off keys, add or remove people, change the name or web address, hand over or delete the project, send emails to users, change sign-in settings and add custom domains.',
  'members.owner': 'Owner',
  'members.you': '(you)',
  'members.status.active': 'Can help',
  'members.status.invited': 'Waiting for them to sign in',
  'members.empty': 'No collaborators yet.',
  'members.invite.title': 'Add a collaborator',
  'members.invite.label': 'Their email address',
  'members.invite.help':
    'If they already have a {product} account with this address, they can help right away. If not, they create one with this address and confirm it. We email them either way.',
  'members.invite.send': 'Add',
  'members.invite.sending': 'Adding…',
  'members.invite.invalid': 'Enter a full email address.',
  'members.invite.self': 'This is your own email address. You already own this project.',
  'members.invite.exists': 'This person is already on the list.',
  'members.invite.full': 'A project can have up to {limit} collaborators. Remove someone first.',
  'members.invite.sent': 'Added {email}.',
  'members.remove': 'Remove',
  'members.remove.confirmTitle': 'Remove {email}?',
  'members.remove.confirmBody': 'They can no longer open this project, and AI agents they connected stop working on it. They get an email.',
  'members.remove.done': 'Removed {email}.',
  'members.leave': 'Stop helping with this project',
  'members.leave.confirmTitle': 'Stop helping with this project?',
  'members.leave.confirmBody': 'You can no longer open it. To help again, the owner has to add you again.',
  'members.error.exists': 'This person is already a collaborator (or has an open invitation).',
  'members.error.limit': 'This project already has the most collaborators it can have. Remove someone first.',
  'members.error.hold': 'Your account had a recent security change (for example a new password). To keep your projects safe, you can add collaborators 72 hours after that change.',
  'members.error.ownerCannotLeave': 'You own this project. To stop owning it, hand it over or delete it.',
  'members.ownerOnly.title': 'Only the owner can use this',
  'members.ownerOnly.body': 'Only the project owner can do this. Collaborators can fix, publish and run the app, but not money, keys, people, handover or deletion.',
  'members.ownerOnly.inline': 'Only the owner can change this.',
  'members.badge': 'Helping',
  'members.publishNotice': 'You are a collaborator: when you update the published app, the owner gets an email.',

  // 渡す画面（渡した後も手伝う）・受け取る画面
  'transfer.stay.label': 'Keep helping after the handover (stay on as a collaborator)',
  'transfer.stay.help': 'You can still fix and publish the app. Money, keys and the people on the project belong to the new owner, and they can remove you at any time.',
  'transfer.noAccessStay': 'After the handover you stay on as a collaborator. Your server-only keys (starting with sk_) stop working and AI agents you connected must be connected again.',
  'transfer.in.stays': 'The current owner stays on as a collaborator after you accept, so they can keep fixing and publishing the app. You can remove them on the Members page at any time.',
  'transfer.in.membersRemoved': 'People who were helping the current owner lose access when you accept.',
} as const;
